import CityPageTemplate from "../city-template/CityPageTemplate";
import { reynoldsburgConfig } from "./data";

export default function ReynoldsburgPage() {
  return <CityPageTemplate config={reynoldsburgConfig} />;
}